import { render } from "./loading-modal.vue?vue&type=template&id=03335936&scoped=true"
import script from "./loading-modal.vue?vue&type=script&lang=js"
export * from "./loading-modal.vue?vue&type=script&lang=js"

import "./loading-modal.vue?vue&type=style&index=0&id=03335936&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ssradius\\frontend_tr\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03335936"]])

export default __exports__